import en from '../shared/locales/en';
import nl from '../shared/locales/nl';

const locales = { en, nl };

export default (item, locale) => locales[locale][item];
